import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { AddcitationmanualpaymentmodalComponent } from './addcitationmanualpaymentmodal.component';


@Component({
    selector: 'app-addcitationmanualpayment',
    templateUrl: './addcitationmanualpayment.component.html',
    styleUrls: ['./addcitationmanualpayment.component.scss'],
    standalone: false
})
export class AddcitationmanualpaymentComponent implements OnInit {

    public PaymentOptions: any[] = [];
    @Input()
    public Citation: any = null;

    public SelectedOption: any = null;
    public NoteContent: string = '';

    public PaymentType: string = 'full';
    public PaymentAmount: number|null = null;

    public Animate : boolean = false;

    constructor(private apiService: ApiServiceBase, private toastService: ToastrService, private _parent: AddcitationmanualpaymentmodalComponent) {
      apiService.Get<any>("payments/providers/options/manual").then(result => {
        this.PaymentOptions = result || [];
      }).catch((error) => {
        console.error("Failed to load manual payment provider options", error);
        this.PaymentOptions = [];
        this.toastService.error("Failed to load payment provider options.");
      });
  }

  public ngOnInit(): void {
  }

  onAmountChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if(input.value == '') {
      return;
    }
    const amount = Number(input.value);
    if(Number.isNaN(amount)) {
      this.PaymentAmount = 0.01;
    } else if(amount > this.Citation.TotalOutstanding) {
      this.PaymentAmount = this.Citation.TotalOutstanding;
    } else if(amount <= 0) {
      this.PaymentAmount = 0.01;
    } else {
      this.PaymentAmount = amount;
    }
    input.value = (this.PaymentAmount ?? "").toString();
  }

  public confirm() {
    if(!this.Citation?.Id) {
      this.toastService.error("Citation not loaded.");
      return;
    }
    if(this.Citation?.IsWarning) {
      this.toastService.error("Cannot record payments against warning citations.");
      return;
    }
    if(!this.SelectedOption?.Type) {
      this.toastService.error("Please select a payment type.");
      return;
    }
    if(!(this.NoteContent || '').trim()) {
      this.toastService.error("A note is required.");
      return;
    }
    if(this.PaymentType == 'partial') {
      if(this.PaymentAmount == null) {
        this.toastService.error("Please enter a payment amount.");
        return;
      }
      if(this.PaymentAmount <= 0) {
        this.toastService.error("Payment amount must be greater than zero.");
        return;
      }
      if(this.PaymentAmount > this.Citation.TotalOutstanding) {
        this.toastService.error(`Payment amount cannot exceed the outstanding balance (${this.Citation.TotalOutstanding}).`);
        return;
      }
    } else if (this.PaymentType != 'full') {
      this.toastService.error("Please select a payment type");
      return;
    }

    this.Animate = true;
    const payload: any = {
      PaymentType: this.SelectedOption.Type,
      NoteContent: this.NoteContent
    };

    if (this.PaymentType == 'partial') {
      payload.PaymentAmount = this.PaymentAmount;
    } else {
      payload.PaymentAmount = this.Citation.TotalOutstanding;
    }

    this.apiService.Post(`enforcement/citations/${this.Citation.Id}/payments/manual`, payload).then(() => {
      this.Animate = false;
      this._parent.close();
    }).catch((err) => {
      this.Animate = false;
      const apiMsg =
        err?.error?.Error?.Message ||
        err?.error?.Error?.message ||
        err?.error?.error ||
        err?.message;
      // Close modal on server error, leave toast visible.
      this._parent.close();
      this.toastService.error(apiMsg || "Failed to record manual payment.");
    });
  }

  public close() {
    this._parent.close();
  }
}
